<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* =========================================================
   Hide "ORGANIC COTTON" block when product has tag: nonorganic
   Put this into Assets -> custom.js (or Custom.js)
   ========================================================= */
(function () {
  var TAG_TO_HIDE = "nonorganic";
  var BLOCK_SELECTOR = ".productView-customText";
  // Eğer başlık metni farklıysa burayı değiştirin:
  var TARGET_TITLE_CONTAINS = "organic cotton";

  function normalize(str) {
    return String(str || "").trim().toLowerCase();
  }

  function parseTags(tagsValue) {
    if (!tagsValue) return [];
    if (Array.isArray(tagsValue)) return tagsValue;
    if (typeof tagsValue === "string") {
      // Shopify /products/<handle>.js genelde tags'i "tag1, tag2" şeklinde döner
      return tagsValue
        .split(",")
        .map(function (t) { return t.trim(); })
        .filter(Boolean);
    }
    return [];
  }

  function getProductHandleFromPath() {
    var path = window.location.pathname || "";
    var marker = "/products/";
    var idx = path.indexOf(marker);
    if (idx === -1) return null;
    var rest = path.slice(idx + marker.length);
    var handle = rest.split("/")[0];
    return handle ? handle : null;
  }

  function getRootPath() {
    // Shopify çok dilli mağazalarda root "/en/" gibi olabilir
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    if (root.slice(-1) !== "/") root += "/";
    return root;
  }

  function tagsFromDataAttribute() {
    // İsterseniz ilgili bloğa data-product-tags ekleyebilirsiniz:
    // <div class="productView-customText" data-product-tags="{{ product.tags | join: ',' }}">
    var el = document.querySelector(BLOCK_SELECTOR + "[data-product-tags]");
    if (!el) return null;
    var raw = el.getAttribute("data-product-tags");
    if (!raw) return null;
    return raw
      .split(",")
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
  }

  function tagsFromInlineProductJson() {
    // Birçok temada product JSON şu şekilde oluyor:
    // <script type="application/json" id="ProductJson-...">{...}</script>
    // veya ProductJSON-...
    var selectors = [
      'script[type="application/json"][id^="ProductJson"]',
      'script[type="application/json"][id^="ProductJSON"]',
      'script[type="application/json"][id*="ProductJson"]',
      'script[type="application/json"][data-product-json]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var s = document.querySelector(selectors[i]);
      if (!s) continue;
      try {
        var obj = JSON.parse(s.textContent);
        if (obj && obj.tags) return parseTags(obj.tags);
        if (obj && obj.product && obj.product.tags) return parseTags(obj.product.tags);
      } catch (e) {
        // ignore
      }
    }
    return null;
  }

  function setVisibility(shouldHide) {
    var blocks = document.querySelectorAll(BLOCK_SELECTOR);
    if (!blocks || !blocks.length) return;

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];

      // Aynı class'ı kullanan başka bloklar varsa, sadece başlığı "ORGANIC COTTON" olanı hedefle
      var titleEl = block.querySelector(".product__text.title");
      var title = titleEl ? normalize(titleEl.textContent) : "";

      // Eğer sayfada tek blok varsa başlık kontrolüne takılmadan uygula
      var isTarget =
        (blocks.length === 1) ||
        (title && title.indexOf(TARGET_TITLE_CONTAINS) !== -1);

      if (isTarget) {
        block.hidden = !!shouldHide; // hidden=true => display:none
      }
    }
  }

  function hasNonOrganicTag(tags) {
    var normalized = (tags || []).map(normalize);
    return normalized.indexOf(TAG_TO_HIDE) !== -1;
  }

  function run() {
    // Bu blok yoksa hiç uğraşma
    if (!document.querySelector(BLOCK_SELECTOR)) return;

    // 1) Data attribute’dan oku (opsiyonel)
    var tags = tagsFromDataAttribute();
    if (tags && tags.length) {
      setVisibility(hasNonOrganicTag(tags));
      return;
    }

    // 2) Temanın inline product JSON’undan oku
    tags = tagsFromInlineProductJson();
    if (tags && tags.length) {
      setVisibility(hasNonOrganicTag(tags));
      return;
    }

    // 3) Fallback: /products/<handle>.js üzerinden ürünü çek
    var handle = getProductHandleFromPath();
    if (!handle) return; // ürün sayfası değilse çık

    var url = getRootPath() + "products/" + encodeURIComponent(handle) + ".js";

    fetch(url, { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product) return;
        var fetchedTags = parseTags(product.tags);
        if (!fetchedTags.length) return;
        setVisibility(hasNonOrganicTag(fetchedTags));
      })
      .catch(function () {
        // Sessizce geç
      });
  }

  // İlk yükleme
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Shopify tema editörü section reload (gerekirse)
  document.addEventListener("shopify:section:load", run);
})();
